import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, createBlock as _createBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/images/claim/rect.png'


const _withScopeId = n => (_pushScopeId("data-v-5e401b1c"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "claim-wrap" }
const _hoisted_2 = {
  class: "feature-con",
  ref: "searchCon"
}
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("section", null, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_0,
    class: "rect"
  }),
  /*#__PURE__*/_createElementVNode("strong", { class: "wrap-title" }, "Demo Car Tracking Report ")
], -1))
const _hoisted_4 = { class: "featureConBox" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "item-name" }, "BU", -1))
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "item-name" }, "Region", -1))
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "item-name" }, "Sub Region", -1))
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "item-name" }, "Make", -1))
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "item-name" }, "Type Class", -1))
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "item-name" }, "Program From (Year)", -1))
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "item-name" }, "Program From (Q/M)", -1))
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "item-name" }, "Claim Period (Year)", -1))
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "item-name" }, "Claim Period (Q/M)", -1))
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "item-name" }, "Dealer Code", -1))
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "item-name" }, "Dealer Name (CN/EN)", -1))
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "item-name" }, "Dealer Group (CN/EN)", -1))
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "item-name" }, " ", -1))
const _hoisted_18 = /*#__PURE__*/_createTextVNode("Reset")
const _hoisted_19 = { class: "pageBtnBox featureConBox" }
const _hoisted_20 = /*#__PURE__*/_createTextVNode("Download")
const _hoisted_21 = /*#__PURE__*/_createTextVNode("Search")
const _hoisted_22 = { class: "table-box" }
const _hoisted_23 = { class: "tabTableBox" }
const _hoisted_24 = { class: "tabTableBox subTitTable" }
const _hoisted_25 = /*#__PURE__*/_createTextVNode("Cancel")
const _hoisted_26 = /*#__PURE__*/_createTextVNode("Download")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Breadcrumb = _resolveComponent("Breadcrumb")!
  const _component_a_select_option = _resolveComponent("a-select-option")!
  const _component_a_select = _resolveComponent("a-select")!
  const _component_a_space = _resolveComponent("a-space")!
  const _component_a_date_picker = _resolveComponent("a-date-picker")!
  const _component_a_tree_select = _resolveComponent("a-tree-select")!
  const _component_a_input = _resolveComponent("a-input")!
  const _component_a_button = _resolveComponent("a-button")!
  const _component_a_table = _resolveComponent("a-table")!
  const _component_a_tab_pane = _resolveComponent("a-tab-pane")!
  const _component_a_progress = _resolveComponent("a-progress")!
  const _component_a_tabs = _resolveComponent("a-tabs")!
  const _component_a_modal = _resolveComponent("a-modal")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_Breadcrumb, { dataSource: [] }),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _hoisted_3,
        _createElementVNode("div", _hoisted_4, [
          _createVNode(_component_a_space, {
            direction: "vertical",
            class: "featureConSpace"
          }, {
            default: _withCtx(() => [
              _hoisted_5,
              _createVNode(_component_a_select, {
                value: _ctx.parameterList.bu,
                "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.parameterList.bu) = $event)),
                ref: "select",
                placeholder: "Please select",
                class: "sel-inp-size",
                onChange: _cache[1] || (_cache[1] = 
                            (vaule) => {
                                _ctx.dogetRegion([vaule]);
                                _ctx.dogetMake([vaule]);
                                _ctx.showCheckingRound([vaule]);
                            }
                        )
              }, {
                default: _withCtx(() => [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.businessUnitSelect, (item) => {
                    return (_openBlock(), _createBlock(_component_a_select_option, {
                      value: item.nameEn,
                      key: item.nameEn,
                      title: item.nameEn
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(item.nameEn), 1)
                      ]),
                      _: 2
                    }, 1032, ["value", "title"]))
                  }), 128))
                ]),
                _: 1
              }, 8, ["value"])
            ]),
            _: 1
          }),
          _createVNode(_component_a_space, {
            direction: "vertical",
            class: "featureConSpace"
          }, {
            default: _withCtx(() => [
              _hoisted_6,
              _createVNode(_component_a_select, {
                value: _ctx.parameterList.region,
                "onUpdate:value": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.parameterList.region) = $event)),
                ref: "select",
                disabled: _ctx.regiondis,
                placeholder: "Please select",
                "allow-clear": "",
                class: "sel-inp-size",
                onChange: _ctx.dogetSubregion
              }, {
                default: _withCtx(() => [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.regionLst, (item) => {
                    return (_openBlock(), _createBlock(_component_a_select_option, {
                      value: item.regionEn,
                      key: item.regionEn,
                      title: item.regionEn
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(item.regionEn), 1)
                      ]),
                      _: 2
                    }, 1032, ["value", "title"]))
                  }), 128))
                ]),
                _: 1
              }, 8, ["value", "disabled", "onChange"])
            ]),
            _: 1
          }),
          _createVNode(_component_a_space, {
            direction: "vertical",
            class: "featureConSpace"
          }, {
            default: _withCtx(() => [
              _hoisted_7,
              _createVNode(_component_a_select, {
                value: _ctx.parameterList.subRegion,
                "onUpdate:value": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.parameterList.subRegion) = $event)),
                ref: "select",
                disabled: _ctx.subregiondis,
                placeholder: "Please select",
                class: "sel-inp-size",
                "allow-clear": ""
              }, {
                default: _withCtx(() => [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.subregionLst, (item) => {
                    return (_openBlock(), _createBlock(_component_a_select_option, {
                      value: item.regionEn,
                      key: item.regionEn,
                      title: item.regionEn
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(item.regionEn), 1)
                      ]),
                      _: 2
                    }, 1032, ["value", "title"]))
                  }), 128))
                ]),
                _: 1
              }, 8, ["value", "disabled"])
            ]),
            _: 1
          }),
          _createVNode(_component_a_space, {
            direction: "vertical",
            class: "featureConSpace"
          }, {
            default: _withCtx(() => [
              _hoisted_8,
              _createVNode(_component_a_select, {
                value: _ctx.parameterList.make,
                "onUpdate:value": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.parameterList.make) = $event)),
                ref: "select",
                placeholder: "Please select",
                class: "sel-inp-size"
              }, {
                default: _withCtx(() => [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.makeOptions, (item) => {
                    return (_openBlock(), _createBlock(_component_a_select_option, {
                      value: item.make,
                      key: item.make,
                      title: item.make
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(item.make), 1)
                      ]),
                      _: 2
                    }, 1032, ["value", "title"]))
                  }), 128))
                ]),
                _: 1
              }, 8, ["value"])
            ]),
            _: 1
          }),
          _createVNode(_component_a_space, {
            direction: "vertical",
            class: "featureConSpace"
          }, {
            default: _withCtx(() => [
              _hoisted_9,
              _createVNode(_component_a_select, {
                value: _ctx.parameterList.typeClass,
                "onUpdate:value": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.parameterList.typeClass) = $event)),
                ref: "select",
                placeholder: "Please select",
                class: "sel-inp-size",
                "show-search": "",
                allowClear: ""
              }, {
                default: _withCtx(() => [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.typeClassOptions, (item, index) => {
                    return (_openBlock(), _createBlock(_component_a_select_option, {
                      value: item,
                      key: index
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(item), 1)
                      ]),
                      _: 2
                    }, 1032, ["value"]))
                  }), 128))
                ]),
                _: 1
              }, 8, ["value"])
            ]),
            _: 1
          }),
          _createVNode(_component_a_space, {
            direction: "vertical",
            class: "featureConSpace"
          }, {
            default: _withCtx(() => [
              _hoisted_10,
              _createVNode(_component_a_date_picker, {
                mode: "year",
                valueFormat: "YYYY",
                format: "YYYY",
                style: {"width":"100%"},
                value: _ctx.programPeriodYear,
                "onUpdate:value": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.programPeriodYear) = $event)),
                open: _ctx.openProgramPeriodYear,
                onOpenChange: _ctx.handlerOpenProgramPeriodChange,
                placeholder: "Please select",
                onPanelChange: _ctx.handlerPanelProgramPeriodChange,
                onChange: _ctx.programPeriodChange
              }, null, 8, ["value", "open", "onOpenChange", "onPanelChange", "onChange"])
            ]),
            _: 1
          }),
          _createVNode(_component_a_space, {
            direction: "vertical",
            class: "featureConSpace"
          }, {
            default: _withCtx(() => [
              _hoisted_11,
              _createVNode(_component_a_tree_select, {
                maxTagCount: 2,
                value: _ctx.programPeriodQM,
                "onUpdate:value": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.programPeriodQM) = $event)),
                style: {"width":"100%"},
                "tree-data": _ctx.qmOptions,
                "tree-checkable": "",
                "allow-clear": "",
                disabled: _ctx.programPeriodDis,
                "show-checked-strategy": _ctx.SHOW_PARENT,
                placeholder: "Please select",
                "search-placeholder": "Please select"
              }, null, 8, ["value", "tree-data", "disabled", "show-checked-strategy"])
            ]),
            _: 1
          }),
          _createVNode(_component_a_space, {
            direction: "vertical",
            class: "featureConSpace"
          }, {
            default: _withCtx(() => [
              _hoisted_12,
              _createVNode(_component_a_date_picker, {
                mode: "year",
                style: {"width":"100%"},
                valueFormat: "YYYY",
                format: "YYYY",
                placeholder: "Please select",
                open: _ctx.openClaimPeriodYear,
                onOpenChange: _ctx.handlerOpenClaimPeriodChange,
                value: _ctx.claimPeriodYear,
                "onUpdate:value": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.claimPeriodYear) = $event)),
                onPanelChange: _ctx.handlerPanelClaimPeriodChange,
                onChange: _ctx.claimPeriodChange
              }, null, 8, ["open", "onOpenChange", "value", "onPanelChange", "onChange"])
            ]),
            _: 1
          }),
          _createVNode(_component_a_space, {
            direction: "vertical",
            class: "featureConSpace"
          }, {
            default: _withCtx(() => [
              _hoisted_13,
              _createVNode(_component_a_tree_select, {
                maxTagCount: 2,
                value: _ctx.claimPeriodQM,
                "onUpdate:value": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.claimPeriodQM) = $event)),
                style: {"width":"100%"},
                "tree-data": _ctx.qmOptions,
                "tree-checkable": "",
                "allow-clear": "",
                disabled: _ctx.claimPeriodDis,
                "show-checked-strategy": _ctx.SHOW_PARENT,
                "search-placeholder": "Please select",
                placeholder: "Please select",
                onChange: _ctx.claimPeriodQMChange
              }, null, 8, ["value", "tree-data", "disabled", "show-checked-strategy", "onChange"])
            ]),
            _: 1
          }),
          _createVNode(_component_a_space, {
            direction: "vertical",
            class: "featureConSpace"
          }, {
            default: _withCtx(() => [
              _hoisted_14,
              _createVNode(_component_a_input, {
                value: _ctx.parameterList.dealerCode,
                "onUpdate:value": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.parameterList.dealerCode) = $event)),
                placeholder: "Please input"
              }, null, 8, ["value"])
            ]),
            _: 1
          }),
          _createVNode(_component_a_space, {
            direction: "vertical",
            class: "featureConSpace"
          }, {
            default: _withCtx(() => [
              _hoisted_15,
              _createVNode(_component_a_input, {
                value: _ctx.parameterList.dealerName,
                "onUpdate:value": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.parameterList.dealerName) = $event)),
                placeholder: "Please input"
              }, null, 8, ["value"])
            ]),
            _: 1
          }),
          _createVNode(_component_a_space, {
            direction: "vertical",
            class: "featureConSpace"
          }, {
            default: _withCtx(() => [
              _hoisted_16,
              _createVNode(_component_a_input, {
                value: _ctx.parameterList.dealerGroup,
                "onUpdate:value": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.parameterList.dealerGroup) = $event)),
                placeholder: "Please input"
              }, null, 8, ["value"])
            ]),
            _: 1
          }),
          _createVNode(_component_a_space, {
            direction: "vertical",
            class: "featureConSpaceBtn"
          }, {
            default: _withCtx(() => [
              _hoisted_17,
              _createVNode(_component_a_button, { onClick: _ctx.handlerReset }, {
                default: _withCtx(() => [
                  _hoisted_18
                ]),
                _: 1
              }, 8, ["onClick"])
            ]),
            _: 1
          })
        ]),
        _createElementVNode("div", _hoisted_19, [
          (_ctx.$btnPermissions('CCD001'))
            ? (_openBlock(), _createBlock(_component_a_space, {
                key: 0,
                direction: "vertical",
                class: "featureConSpaceBtn"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_a_button, { onClick: _ctx.openDownload }, {
                    default: _withCtx(() => [
                      _hoisted_20
                    ]),
                    _: 1
                  }, 8, ["onClick"])
                ]),
                _: 1
              }))
            : _createCommentVNode("", true),
          (_ctx.$btnPermissions('CCD002'))
            ? (_openBlock(), _createBlock(_component_a_space, {
                key: 1,
                direction: "vertical",
                class: "featureConSpaceBtn"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_a_button, {
                    onClick: _ctx.dogetAllData,
                    type: "primary"
                  }, {
                    default: _withCtx(() => [
                      _hoisted_21
                    ]),
                    _: 1
                  }, 8, ["onClick"])
                ]),
                _: 1
              }))
            : _createCommentVNode("", true)
        ])
      ], 512),
      _createElementVNode("div", _hoisted_22, [
        _createVNode(_component_a_tabs, {
          "default-active-key": "1",
          onChange: _ctx.tabChange
        }, {
          default: _withCtx(() => [
            _createVNode(_component_a_tab_pane, {
              key: "1",
              tab: "Dealer Based"
            }, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_23, [
                  _createVNode(_component_a_table, {
                    class: "ant-table-striped",
                    rowKey: "id",
                    bordered: "",
                    columns: _ctx.dealerCol,
                    "data-source": _ctx.dealerListData,
                    pagination: false,
                    scroll: { x: _ctx.tableWidth, y: _ctx.tableHeight },
                    rowClassName: 
                                (record, index) =>
                                    index % 2 === 1 ? 'table-striped' : null
                            
                  }, null, 8, ["columns", "data-source", "scroll", "rowClassName"])
                ])
              ]),
              _: 1
            }),
            _createVNode(_component_a_tab_pane, {
              key: "2",
              tab: "Program Based"
            }, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_24, [
                  _createVNode(_component_a_table, {
                    class: "ant-table-striped",
                    rowKey: "id",
                    columns: _ctx.programCol,
                    "data-source": _ctx.programListData,
                    pagination: false,
                    scroll: { x: _ctx.tableWidth, y: _ctx.tableHeight2 },
                    bordered: "",
                    rowClassName: 
                                (record, index) =>
                                    index % 2 === 1 ? 'table-striped' : null
                            
                  }, {
                    programPeriod: _withCtx(({record}) => [
                      _createElementVNode("span", null, _toDisplayString(record.eligiblePeriodFrom) + " - " + _toDisplayString(record.eligiblePeriodTo), 1)
                    ]),
                    checkingFulfillment: _withCtx(({ record }) => [
                      _createElementVNode("div", null, [
                        _createVNode(_component_a_progress, {
                          percent: record.checkingFulfillment
                        }, null, 8, ["percent"])
                      ])
                    ]),
                    finalPassRate: _withCtx(({ record }) => [
                      _createElementVNode("div", null, [
                        _createVNode(_component_a_progress, {
                          percent: record.finalPassRateNum
                        }, null, 8, ["percent"])
                      ])
                    ]),
                    _: 1
                  }, 8, ["columns", "data-source", "scroll", "rowClassName"])
                ])
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["onChange"])
      ])
    ]),
    _createVNode(_component_a_modal, {
      visible: _ctx.downloadVisible,
      title: "Download",
      onCancel: _ctx.closeDownload
    }, {
      footer: _withCtx(() => [
        _createVNode(_component_a_button, {
          key: "back",
          onClick: _ctx.closeDownload
        }, {
          default: _withCtx(() => [
            _hoisted_25
          ]),
          _: 1
        }, 8, ["onClick"]),
        _createVNode(_component_a_button, {
          key: "submit",
          type: "primary",
          onClick: _ctx.handlerDownload
        }, {
          default: _withCtx(() => [
            _hoisted_26
          ]),
          _: 1
        }, 8, ["onClick"])
      ]),
      default: _withCtx(() => [
        _createVNode(_component_a_table, {
          "row-selection": _ctx.downloadRowSelection,
          columns: _ctx.downloadColumnsData,
          pagination: false,
          dataSource: _ctx.downloadTableData,
          rowKey: "fileType"
        }, null, 8, ["row-selection", "columns", "dataSource"])
      ]),
      _: 1
    }, 8, ["visible", "onCancel"])
  ], 64))
}